import React from 'react';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';
import AppText from './atoms/AppText';
import { DeleteAccountDialogProps } from '../types/ProfileMenu.types';

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({ open, onClose, onConfirm }) => {
    const { t } = useTranslation();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} sx={{ boxShadow: 0 }}>
            <DialogContent sx={{ textAlign: 'center', width: 350 }}>
                <InfoIcon sx={{ width: 70, height: 70, p: 1, color: '#656563' }} />
                <AppText
                    textSize={14}
                    style={{
                        mt: 1,
                        textAlign: 'center',
                        ':first-letter': 'Uppercase',
                        fontWeight: 550
                    }}
                >
                    {t('web.popupMenu-delete-alert-text', 'Are you sure you want to delete your account?')}
                </AppText>
                <AppText
                    textSize={12}
                    style={{
                        mt: 1,
                        textAlign: 'center',
                        ':first-letter': 'Uppercase'
                    }}
                >
                    {t('web.popupMenu-delete-account-alert', 'This action cannot be undone.')}
                </AppText>
            </DialogContent>
            <DialogActions>
                <Button
                    sx={{
                        fontSize: 12,
                        bgcolor: '#9A9FA5',
                        color: 'black',
                        '&:hover': { bgcolor: '#9A9FA5' }
                    }}
                    fullWidth
                    onClick={onClose}
                >
                    {t('web.activities-alert-no-btn', 'Cancel')}
                </Button>
                <Button
                    onClick={handleConfirm}
                    sx={{
                        fontSize: 12,
                        bgcolor: 'red',
                        color: 'white',
                        '&:hover': { bgcolor: 'red' }
                    }}
                    fullWidth
                >
                    {t('web.activities-alert-yes-btn', 'Delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteAccountDialog;

